import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ViajeDTO } from '../../../dtos/viaje.dto';
import { ViajeService } from '../../services/viaje.service';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-iniciar-viaje',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-iniciar-viaje.component.html',
  styleUrl: './modal-iniciar-viaje.component.scss'
})
export class ModalIniciarViajeComponent implements OnInit {
  viaje: ViajeDTO | null = null;
  combustiblePorcentaje: number = 50; // Valor por defecto
  enviando: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private viajeService: ViajeService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // El viaje se pasa desde el componente despachador a través de initialState
  }

  close(): void {
    this.bsModalRef.hide();
  }

  tienePermisoIniciarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_INICIAR');
  }

  iniciarViaje(): void {
    if (this.viaje) {
      this.enviando = true;
      this.viajeService.iniciarViaje(this.viaje.uuid, this.combustiblePorcentaje).subscribe({
        next: (response) => {
          if (response.success) {
            console.log('Viaje iniciado exitosamente');

            // Publish event to notify that a viaje has been started
            // This will trigger a refresh in the despachador component
            if (this.viaje) {
              console.log("publicando evento")
              this.eventService.publish('VIAJE_INICIADO_EVENT', this.viaje);
            }

            this.enviando = false;
            // Cerrar el modal después de iniciar el viaje
            this.close();
          } else {
            console.error('Error al iniciar viaje:', response.msg);
            this.enviando = false;
            this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          }
        },
        error: (error) => {
          this.enviando = false;
          this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
        }
      });
    }
  }
}
